/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { UnistackAccountListRsp } from '../models/unistack-account-list-rsp';
import { UnistackAccount } from '../models/unistack-account';
import { UnistackAccountCreateReq } from '../models/unistack-account-create-req';
import { UnistackAccountAuthReq } from '../models/unistack-account-auth-req';
import { UnistackAccountRegisterReq } from '../models/unistack-account-register-req';
import { UnistackAccountUpdateReq } from '../models/unistack-account-update-req';
import { UnistackAccountDeleteRsp } from '../models/unistack-account-delete-rsp';
@Injectable({
  providedIn: 'root',
})
class AccountServiceService extends __BaseService {
  static readonly AccountListPath = '/api/unistack/v0/accounts';
  static readonly AccountCreatePath = '/api/unistack/v0/accounts';
  static readonly AccountAuthPath = '/api/unistack/v0/accounts/auth';
  static readonly AccountRegisterPath = '/api/unistack/v0/accounts/register';
  static readonly AccountSearchPath = '/api/unistack/v0/accounts/search';
  static readonly AccountLookupPath = '/api/unistack/v0/accounts/{uuid}';
  static readonly AccountUpdatePath = '/api/unistack/v0/accounts/{uuid}';
  static readonly AccountDeletePath = '/api/unistack/v0/accounts/{uuid}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `AccountServiceService.AccountListParams` containing the following parameters:
   *
   * - `sort`:
   *
   * - `rsp_fields`:
   *
   * - `req_fields`:
   *
   * - `order`:
   *
   * - `meta.sort`:
   *
   * - `meta.order`:
   *
   * - `meta.offset`:
   *
   * - `meta.limit`:
   *
   * @return A successful response.
   */
  AccountListResponse(params: AccountServiceService.AccountListParams): __Observable<__StrictHttpResponse<UnistackAccountListRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    (params.sort || []).forEach(val => {if (val != null) __params = __params.append('sort', val.toString())});
    (params.rspFields || []).forEach(val => {if (val != null) __params = __params.append('rsp_fields', val.toString())});
    (params.reqFields || []).forEach(val => {if (val != null) __params = __params.append('req_fields', val.toString())});
    if (params.order != null) __params = __params.set('order', params.order.toString());
    if (params.metaSort != null) __params = __params.set('meta.sort', params.metaSort.toString());
    if (params.metaOrder != null) __params = __params.set('meta.order', params.metaOrder.toString());
    if (params.metaOffset != null) __params = __params.set('meta.offset', params.metaOffset.toString());
    if (params.metaLimit != null) __params = __params.set('meta.limit', params.metaLimit.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/unistack/v0/accounts`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackAccountListRsp>;
      })
    );
  }
  /**
   * @param params The `AccountServiceService.AccountListParams` containing the following parameters:
   *
   * - `sort`:
   *
   * - `rsp_fields`:
   *
   * - `req_fields`:
   *
   * - `order`:
   *
   * - `meta.sort`:
   *
   * - `meta.order`:
   *
   * - `meta.offset`:
   *
   * - `meta.limit`:
   *
   * @return A successful response.
   */
  AccountList(params: AccountServiceService.AccountListParams): __Observable<UnistackAccountListRsp> {
    return this.AccountListResponse(params).pipe(
      __map(_r => _r.body as UnistackAccountListRsp)
    );
  }

  /**
   * @param body undefined
   * @return A successful response.
   */
  AccountCreateResponse(body: UnistackAccountCreateReq): __Observable<__StrictHttpResponse<UnistackAccount>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/unistack/v0/accounts`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackAccount>;
      })
    );
  }
  /**
   * @param body undefined
   * @return A successful response.
   */
  AccountCreate(body: UnistackAccountCreateReq): __Observable<UnistackAccount> {
    return this.AccountCreateResponse(body).pipe(
      __map(_r => _r.body as UnistackAccount)
    );
  }

  /**
   * @param body undefined
   * @return A successful response.
   */
  AccountAuthResponse(body: UnistackAccountAuthReq): __Observable<__StrictHttpResponse<UnistackAccount>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/unistack/v0/accounts/auth`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackAccount>;
      })
    );
  }
  /**
   * @param body undefined
   * @return A successful response.
   */
  AccountAuth(body: UnistackAccountAuthReq): __Observable<UnistackAccount> {
    return this.AccountAuthResponse(body).pipe(
      __map(_r => _r.body as UnistackAccount)
    );
  }

  /**
   * @param body undefined
   * @return A successful response.
   */
  AccountRegisterResponse(body: UnistackAccountRegisterReq): __Observable<__StrictHttpResponse<UnistackAccount>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/unistack/v0/accounts/register`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackAccount>;
      })
    );
  }
  /**
   * @param body undefined
   * @return A successful response.
   */
  AccountRegister(body: UnistackAccountRegisterReq): __Observable<UnistackAccount> {
    return this.AccountRegisterResponse(body).pipe(
      __map(_r => _r.body as UnistackAccount)
    );
  }

  /**
   * @return A successful response.
   */
  AccountSearchResponse(): __Observable<__StrictHttpResponse<UnistackAccountListRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/unistack/v0/accounts/search`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackAccountListRsp>;
      })
    );
  }
  /**
   * @return A successful response.
   */
  AccountSearch(): __Observable<UnistackAccountListRsp> {
    return this.AccountSearchResponse().pipe(
      __map(_r => _r.body as UnistackAccountListRsp)
    );
  }

  /**
   * @param params The `AccountServiceService.AccountLookupParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  AccountLookupResponse(params: AccountServiceService.AccountLookupParams): __Observable<__StrictHttpResponse<UnistackAccount>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    (params.fields || []).forEach(val => {if (val != null) __params = __params.append('fields', val.toString())});
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/unistack/v0/accounts/${params.uuid}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackAccount>;
      })
    );
  }
  /**
   * @param params The `AccountServiceService.AccountLookupParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  AccountLookup(params: AccountServiceService.AccountLookupParams): __Observable<UnistackAccount> {
    return this.AccountLookupResponse(params).pipe(
      __map(_r => _r.body as UnistackAccount)
    );
  }

  /**
   * @param params The `AccountServiceService.AccountUpdateParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `body`:
   *
   * @return A successful response.
   */
  AccountUpdateResponse(params: AccountServiceService.AccountUpdateParams): __Observable<__StrictHttpResponse<UnistackAccount>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.body;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/unistack/v0/accounts/${params.uuid}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackAccount>;
      })
    );
  }
  /**
   * @param params The `AccountServiceService.AccountUpdateParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `body`:
   *
   * @return A successful response.
   */
  AccountUpdate(params: AccountServiceService.AccountUpdateParams): __Observable<UnistackAccount> {
    return this.AccountUpdateResponse(params).pipe(
      __map(_r => _r.body as UnistackAccount)
    );
  }

  /**
   * @param uuid undefined
   * @return A successful response.
   */
  AccountDeleteResponse(uuid: string): __Observable<__StrictHttpResponse<UnistackAccountDeleteRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/unistack/v0/accounts/${uuid}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackAccountDeleteRsp>;
      })
    );
  }
  /**
   * @param uuid undefined
   * @return A successful response.
   */
  AccountDelete(uuid: string): __Observable<UnistackAccountDeleteRsp> {
    return this.AccountDeleteResponse(uuid).pipe(
      __map(_r => _r.body as UnistackAccountDeleteRsp)
    );
  }
}

module AccountServiceService {

  /**
   * Parameters for AccountList
   */
  export interface AccountListParams {
    sort?: Array<'field_all' | 'field_uuid' | 'field_status' | 'field_type' | 'field_created_at' | 'field_updated_at' | 'field_deleted_at'>;
    rspFields?: Array<'field_all' | 'field_uuid' | 'field_status' | 'field_type' | 'field_created_at' | 'field_updated_at' | 'field_deleted_at'>;
    reqFields?: Array<'field_all' | 'field_uuid' | 'field_status' | 'field_type' | 'field_created_at' | 'field_updated_at' | 'field_deleted_at'>;
    order?: 'order_asc' | 'order_dsc';
    metaSort?: string;
    metaOrder?: string;
    metaOffset?: string;
    metaLimit?: string;
  }

  /**
   * Parameters for AccountLookup
   */
  export interface AccountLookupParams {
    uuid: string;
    fields?: Array<'field_all' | 'field_name' | 'field_uuid' | 'field_status' | 'field_enabled' | 'field_type' | 'field_created_at' | 'field_updated_at' | 'field_deleted_at' | 'field_perms'>;
  }

  /**
   * Parameters for AccountUpdate
   */
  export interface AccountUpdateParams {
    uuid: string;
    body: UnistackAccountUpdateReq;
  }
}

export { AccountServiceService }
